import { languageService } from "../../../../Language/language.service";

const dateTimeFormat = "MM-DD-yy HH:mm";
const timeFormat = "HH:mm";

export const HOSEntrySchema = {
  title: languageService("Add Duty Time"),
  id: "HOSEntrySchema",
  stateTitle: {
    create: languageService("Add Duty Time"),
    edit: languageService("Edit Duty Time"),
  },
  sections: [
    {
      id: "hosEntrySection",
      fields: [
        {
          id: "startDate",
          type: "dateTime",
          labelValue: languageService("Start Date & Time"),
          required: true,
          disabledStates: ["edit"],
          format: dateTimeFormat,
        },
        { id: "startTime", type: "time", labelValue: languageService("Start Time"), required: true, hiddenStates: ["create"], format: timeFormat },
        { id: "endDate", type: "dateTime", labelValue: languageService("End Date & Time"), required: true, format: dateTimeFormat },
        { id: "comments", type: "input", labelValue: languageService("Comments"), required: false },
        {
          id: "submitEntrySession",
          type: "button",
          labelValue: languageService("Submit"),
          action: "submit",
          callback: "onHOSFilled",
          position: "footer",
          col: 6,
        },
        {
          id: "cancelEntryDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/User/HOS/schema/hosSchema.js